import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import { motion } from "framer-motion";
import '../styles/pages/top.scss';

// 2:00 PM PDT on 9/5/2026 = 9:00 PM UTC (PDT is UTC-7)
const REVEAL_TIME = new Date(Date.UTC(2026, 8, 5, 21, 0, 0));

const Top = ({isPlaying, setMusic}) => {
    const [isRevealed, setIsRevealed] = useState(Date.now() >= REVEAL_TIME.getTime());

    useEffect(() => {
        if (isRevealed) return; // already past reveal time, no timer needed

        const msUntilReveal = REVEAL_TIME.getTime() - Date.now();
        const timer = setTimeout(() => setIsRevealed(true), msUntilReveal);

        return () => clearTimeout(timer);
    }, [isRevealed]);

    return (
        <div className="top-container">
            {
                <motion.button className={`music-top ${isPlaying ? 'playing' : 'paused'}`}
                    onClick={()=>{
                        setMusic(!isPlaying)
                    }}
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{
                        delay: 4,
                        duration: 1
                    }}
                >
                    
                </motion.button>
            }
            <header>
                <motion.img src={`${process.env.PUBLIC_URL}/img/logo-white.webp`} alt="Yomawari: Lost in the Dark Logo"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{
                        delay: 3,
                        duration: 1
                    }}
                />
                <motion.h1 className="captcha"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{
                        duration: 2
                    }}
                >
                    DON'T LOOK AWAY...
                </motion.h1>
            </header>
            <motion.h1 className="release-date"
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{
                        delay: 5,
                        duration: 2
                    }}              
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center"
                    }}      
                >
                    {isRevealed && (
                        <>
                            <motion.span
                                style={{marginBottom: '20px'}}
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                transition={{duration: 1}}
                            >
                                Coming to PlayStation®5: 11/05/2026
                            </motion.span>
                            <br/><br/>
                        </>
                    )}
                    Available: <br/>
                    US: 10/25/2022, 
                    EU: 10/28/2022, 
                    ANZ: 10/28/2022
                </motion.h1>
            <TopNav/>
            <div className="video-container">
                <div className="video-wrapper">
                    <ReactPlayer url="https://www.youtube.com/watch?v=Z5gWOnu7tSA"/>
                </div>
            </div>
            <a href="https://nisamerica.com/yomawari/find-mugi" target="_blank" rel="noopener noreferrer">
                <img src="./img/logo.png" alt="Find Mugi Banner" className="image-banner"/>
            </a>
            <Spec isRevealed={isRevealed}/>
        </div>
    )
}

const TopNav = () => (
    <div className="top-nav-list">
        <Link to='/story'>
            <h1 className="top-nav-story">
                STORY
            </h1>
        </Link>
        <Link to='/characters'>
            <h1 className="top-nav-characters">
                CHARACTERS
            </h1>
        </Link>
        <Link to='/system'>
            <h1 className="top-nav-system">
                SYSTEM
            </h1>
        </Link>
        <Link to='/media'>
            <h1 className="top-nav-media">
                MEDIA
            </h1>
        </Link>
        <Link to='/products'>
            <h1 className="top-nav-products">
                PRODUCTS
            </h1>
        </Link>
    </div>
)

const Spec = ({isRevealed}) =>  {

    return (
    <section className="text-wrapper">
        <h1 className="text-title">
            Specs
        </h1>
        <table>
            <tbody>
                <tr>
                    <th>Title:</th>
                    <td>Yomawari: Lost in the Dark</td>
                </tr>
                <tr>
                    <th>Release:</th>
                    <td>
                        {isRevealed && (
                            <>
                                Coming to PlayStation®5: <br/> November 05, 2026 <br/> <br/>
                            </>
                        )}
                        US: 10/25/2022, EU:10/28/2022, ANZ: 10/28/2022
                    </td>
                </tr>
                <tr>
                    <th>Platform:</th>
                    <td>Nintendo Switch™, PlayStation®5, PlayStation®4, PC</td>
                </tr>
                <tr>
                    <th>Player(s):</th>
                    <td>1</td>
                </tr>
                <tr>
                    <th>Genre:</th>
                    <td>Survival Horror</td>
                </tr>
                <tr>
                    <th>Text Language:</th>
                    <td>English</td>
                </tr>
            </tbody>
        </table>
    </section>
)
}

export default Top;